import React, { useEffect, useImperativeHandle, useRef } from "react";
import { GanttOptions, GanttTaskInput, GanttTaskOutput } from "./gantt-chart-types";

export interface GanttChartApi {
    getTasks(): GanttTaskOutput[];
}

export const GanttChart = React.forwardRef<
    GanttChartApi,
    {
        tasks: GanttTaskInput[];
        ganttOptions?: Partial<GanttOptions>;
    }
>(function GanttChart(props, ref) {
    const outletRef = useRef<HTMLDivElement>(null);
    const ganttInstanceRef = useRef<Gantt | null>(null);

    useEffect(() => {
        if (!outletRef.current) return;

        const defaultOptions: GanttOptions = {
            container_height: 500,
            infinite_padding: false,
            readonly: true,
        };

        ganttInstanceRef.current = new Gantt("#frappe-gantt-chart-outlet", props.tasks, {
            ...defaultOptions,
            ...props.ganttOptions,
        });

        // Cleanup DOM elements on dependency change
        return () => {
            if (ganttInstanceRef.current) {
                ganttInstanceRef.current.clear();
            }
            ganttInstanceRef.current = null;

            if (outletRef.current) {
                outletRef.current.innerHTML = "";
            }
        };
    }, [props.tasks, props.ganttOptions]);

    useImperativeHandle(
        ref,
        () => ({
            getTasks: () => ganttInstanceRef.current?.tasks ?? [],
        }),
        []
    );

    return <div ref={outletRef} id="frappe-gantt-chart-outlet" className="absolute bottom-0 left-0 right-0 top-0" />;
});
